module.exports = __webpack_public_path__ + "static/img/04.9c9e660.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour3/04.jpg
// module id = 2xRd
// module chunks = 0